// extracted by mini-css-extract-plugin
export default {"button":"DisplayModeSelector_button__PvWyQ","openButton":"DisplayModeSelector_openButton__r7RWq","menuIcon":"DisplayModeSelector_menuIcon__IIs7g"};